import { SkipInterceptorHeader } from './util.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class StaticStorageService {
    skipInterceptorHeader: string = SkipInterceptorHeader;
    constructor(private readonly http: HttpClient) { }

    saveFile(preSignedUrl: string, file: any) {
        const headers = new HttpHeaders().set(SkipInterceptorHeader, '');
        headers.set('response-Type', file.type);
        return this.http.put(preSignedUrl, file, { headers });
    }
}
